import { Named } from "../types";

function sortByNameAscending<Element extends Named>(
  current: Element,
  next: Element,
): number {
  return current.name.localeCompare(next.name);
}

function sortByNameDescending<Element extends Named>(
  current: Element,
  next: Element,
): number {
  return next.name.localeCompare(current.name);
}

export { sortByNameAscending, sortByNameDescending };
